// extracted by mini-css-extract-plugin
export default {"text-header":"ServicesBlock_text-header__bg5iG","padding":"ServicesBlock_padding__kjxWo"};